import { gql } from '@apollo/client';
import { useQuery } from '@tbitop/api';
import { defaultTo } from 'lodash-es';
import type { OffeneAufgabenStatistikQuery } from './__generated__/objekt-aufgaben-statistik';

type OffeneAufgabenStatistik_offeneAufgabenStatistik = OffeneAufgabenStatistikQuery['offeneAufgabenStatistik'];

export const useObjektAufgabenStatistik = () => {
  const { loading, error, data } = useQuery<OffeneAufgabenStatistikQuery>(gql`
    query OffeneAufgabenStatistik {
      offeneAufgabenStatistik {
        anzahlObjekteMitOffenenAufgaben
        anzahlOffen
      }
    }
  `);

  const objektAufgabenStatistik: OffeneAufgabenStatistik_offeneAufgabenStatistik = defaultTo(
    data?.offeneAufgabenStatistik,
    { __typename: 'OffeneAufgabenStatistik', anzahlObjekteMitOffenenAufgaben: 0, anzahlOffen: 0 },
  );

  return {
    loading,
    error,
    objektAufgabenStatistik,
  };
};
